import React, { useMemo } from "react";

const Hearts = ({ count = 18 }) => {
  // Compute particles once per `count` so React reconciliation has stable keys.
  const particles = useMemo(
    () =>
      Array.from({ length: count }).map(() => ({
        id:
          typeof crypto !== "undefined" && crypto.randomUUID
            ? crypto.randomUUID()
            : Math.random().toString(36).slice(2),
        left: Math.random() * 100,
        size: 14 + Math.random() * 28,
        duration: 14 + Math.random() * 16,
        delay: -Math.random() * 30,
        opacity: 0.07 + Math.random() * 0.12,
        drift: (Math.random() * 80 - 40).toFixed(0) + "px",
      })),
    [count]
  );

  return (
    <div aria-hidden>
      {particles.map((p) => (
        <svg
          key={p.id}
          className="heart-particle"
          style={{
            left: `${p.left}%`,
            width: p.size,
            height: p.size,
            "--d": `${p.duration}s`,
            "--delay": `${p.delay}s`,
            "--o": p.opacity,
            "--x": p.drift,
          }}
          viewBox="0 0 24 24"
          fill="currentColor"
          aria-hidden
        >
          <path d="M12 21s-7.5-4.6-9.7-9.1C.7 8 2.8 4 6.5 4c2 0 3.5 1 4.5 2.4C12 5 13.5 4 15.5 4 19.2 4 21.3 8 19.7 11.9 17.5 16.4 12 21 12 21z" />
        </svg>
      ))}
    </div>
  );
};

export default Hearts;
